<template>
  <div class="pt-card-attribute checkbox-group">
    <r-text style="margin-bottom: 8px;" type="caption">
      {{ config.label }}
    </r-text>
    <div class="pt-card-attribute-content">
      <el-checkbox-group v-model="feature[config.prop]">
        <el-checkbox
          class="r-checkbox"
          v-for="value in values[config.values]"
          :label="value.id"
          :key="value.id"
        >
          {{ value.name }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import { values } from "../config";

export default {
  props: ["feature", "config"],
  data() {
    return {
      values: cloneDeep(values)
    };
  },
  methods: {
    async getData() {
      try {
        const url = `objectInfo/${this.config.request}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });
        this.values[this.config.values] = Object.values(data);
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    if (this.config.request) {
      this.getData();
    }
  }
};
</script>

<style lang="scss">
.pt-card-attribute.checkbox-group {
  .pt-card-attribute-content {
    .el-checkbox {
      display: flex;
      align-items: center;

      &:not(:first-child) {
        margin-top: 4px;
      }

      &__label {
        font-size: 12px;
      }
    }
  }
}
</style>
